import { render, staticRenderFns } from "./SafetyYujingDialog.vue?vue&type=template&id=6fe99b20&scoped=true"
import script from "./SafetyYujingDialog.vue?vue&type=script&lang=js"
export * from "./SafetyYujingDialog.vue?vue&type=script&lang=js"
import style0 from "./SafetyYujingDialog.vue?vue&type=style&index=0&id=6fe99b20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe99b20",
  null
  
)

export default component.exports